module.exports = __webpack_public_path__ + "assets/arcadeweb2.jpg?4bcc081a92cbc961639b0acc268da2ee";